import iso639_1 from "./iso639-1.json";

export function languageName(locale) {
  const iso639_1_code = (locale || "").substring(0, 2);
  const obj = iso639_1[iso639_1_code];
  return (obj && obj.name) || iso639_1_code;
}
